import { render, staticRenderFns } from "./SingingTelegramInfoButtons.vue?vue&type=template&id=3cae0125"
import script from "./SingingTelegramInfoButtons.vue?vue&type=script&lang=js"
export * from "./SingingTelegramInfoButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports